import { defineComponent as _, openBlock as l, createElementBlock as g, normalizeClass as h, unref as f, createElementVNode as c, toDisplayString as v, createCommentVNode as w, ref as k, onMounted as C, onBeforeUnmount as E, createBlock as T, Teleport as B, Fragment as D, renderList as A } from "vue";
import { c as y } from "./cn-Bje3WtSp.js";
const L = ["role"], S = { class: "flex items-start gap-3" }, M = { class: "flex-1" }, R = {
  key: 0,
  class: "text-sm font-semibold text-text-primary"
}, V = { class: "text-sm text-text-primary" }, H = /* @__PURE__ */ _({
  __name: "Toast",
  props: {
    severity: { default: "info" },
    title: { default: void 0 },
    message: {},
    class: { default: void 0 }
  },
  emits: ["dismiss"],
  setup(e) {
    const s = {
      success: "border-success bg-success-muted",
      info: "border-info bg-info-muted",
      warning: "border-warning bg-warning-muted",
      danger: "border-danger bg-danger-muted"
    };
    return (d, a) => (l(), g("div", {
      role: e.severity === "warning" || e.severity === "danger" ? "alert" : "status",
      class: h(f(y)(
        "w-[380px] max-w-[calc(100%-32px)] rounded-xl border border-border-default border-l-4 bg-surface-elevated py-3.5 pl-4 pr-3.5 shadow-3",
        s[e.severity],
        d.$props.class
      ))
    }, [
      c("div", S, [
        c("div", M, [
          e.title ? (l(), g("p", R, v(e.title), 1)) : w("", !0),
          c("p", V, v(e.message), 1)
        ]),
        c("button", {
          type: "button",
          class: "rounded px-1 text-text-secondary hover:bg-surface-sunken focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
          "aria-label": "Dismiss",
          onClick: a[0] || (a[0] = (u) => d.$emit("dismiss"))
        }, " × ")
      ])
    ], 10, L));
  }
}), z = 3;
function F() {
  const e = k([]), s = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set();
  let a = 0;
  function u(n) {
    const t = `toast-${++a}-${Date.now()}`, o = {
      id: t,
      severity: n.severity ?? "info",
      title: n.title,
      message: n.message
    }, r = [...e.value, o];
    for (; r.length > z; ) {
      const m = r.shift();
      m && d.forEach(($) => $(m.id));
    }
    return e.value = r, s.forEach((m) => m(o)), t;
  }
  function b(n) {
    const t = e.value.length;
    e.value = e.value.filter((o) => o.id !== n), e.value.length !== t && d.forEach((o) => o(n));
  }
  function p(n) {
    return s.add(n), () => s.delete(n);
  }
  function x(n) {
    return d.add(n), () => d.delete(n);
  }
  return { toasts: e, push: u, dismiss: b, onAdd: p, onRemove: x };
}
const i = F();
function J() {
  return {
    show: (e) => i.push(e),
    success: (e, s) => i.push({ severity: "success", message: e, title: s }),
    info: (e, s) => i.push({ severity: "info", message: e, title: s }),
    warning: (e, s) => i.push({ severity: "warning", message: e, title: s }),
    danger: (e, s) => i.push({ severity: "danger", message: e, title: s }),
    dismiss: (e) => i.dismiss(e)
  };
}
const I = ["role"], N = { class: "flex items-start gap-3" }, q = { class: "flex-1" }, P = {
  key: 0,
  class: "text-sm font-semibold"
}, U = { class: "text-sm" }, X = ["onClick"], K = /* @__PURE__ */ _({
  __name: "ToastProvider",
  props: {
    class: {}
  },
  setup(e) {
    const s = i.toasts, d = {
      success: "border-success bg-success-muted text-text-primary",
      info: "border-info bg-info-muted text-text-primary",
      warning: "border-warning bg-warning-muted text-text-primary",
      danger: "border-danger bg-danger-muted text-text-primary"
    }, a = /* @__PURE__ */ new Map();
    function u(t) {
      if (t.severity === "danger") return;
      const o = t.severity === "warning" ? 1e4 : 5e3;
      a.set(
        t.id,
        setTimeout(() => i.dismiss(t.id), o)
      );
    }
    function b(t) {
      const o = a.get(t);
      o && (clearTimeout(o), a.delete(t));
    }
    function p(t) {
      return t === "warning" || t === "danger" ? "alert" : "status";
    }
    const x = i.onAdd((t) => u(t)), n = i.onRemove((t) => b(t));
    return C(() => {
      s.value.forEach(u);
    }), E(() => {
      x(), n(), a.forEach((t) => clearTimeout(t)), a.clear();
    }), (t, o) => (l(), T(B, { to: "body" }, [
      c("div", {
        "aria-live": "polite",
        class: h(f(y)(
          "pointer-events-none fixed z-[60] flex flex-col gap-2 p-4",
          // Desktop: top-right. Mobile: bottom-center. (§8.7)
          "bottom-0 left-1/2 -translate-x-1/2 md:bottom-auto md:left-auto md:right-0 md:top-0 md:translate-x-0"
        ))
      }, [
        (l(!0), g(D, null, A(f(s), (r) => (l(), g("div", {
          key: r.id,
          role: p(r.severity),
          class: h(f(y)(
            "pointer-events-auto min-w-[280px] max-w-sm rounded-md border-l-4 bg-surface-elevated px-4 py-3 shadow-2",
            d[r.severity]
          ))
        }, [
          c("div", N, [
            c("div", q, [
              r.title ? (l(), g("p", P, v(r.title), 1)) : w("", !0),
              c("p", U, v(r.message), 1)
            ]),
            c("button", {
              type: "button",
              class: "rounded px-1 text-text-secondary hover:bg-surface-sunken focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand",
              "aria-label": "Dismiss",
              onClick: (m) => f(i).dismiss(r.id)
            }, " × ", 8, X)
          ])
        ], 10, I))), 128))
      ], 2)
    ]));
  }
});
export {
  H as _,
  K as a,
  i as t,
  J as u
};
//# sourceMappingURL=ToastProvider.vue_vue_type_script_setup_true_lang-BayMD8s5.js.map
